export interface TimezoneGroup {
  label: string
  zones: {value: string; label: string}[]
}

export const timezoneGroups: TimezoneGroup[] = [
  {
    label: 'Россия',
    zones: [
      {value: 'Europe/Kaliningrad', label: 'Калининград (UTC+2)'},
      {value: 'Europe/Moscow', label: 'Москва (UTC+3)'},
      {value: 'Europe/Samara', label: 'Самара (UTC+4)'},
      {value: 'Asia/Yekaterinburg', label: 'Екатеринбург (UTC+5)'},
      {value: 'Asia/Omsk', label: 'Омск (UTC+6)'},
      {value: 'Asia/Krasnoyarsk', label: 'Красноярск (UTC+7)'},
      {value: 'Asia/Irkutsk', label: 'Иркутск (UTC+8)'},
      {value: 'Asia/Yakutsk', label: 'Якутск (UTC+9)'},
      {value: 'Asia/Vladivostok', label: 'Владивосток (UTC+10)'},
      {value: 'Asia/Magadan', label: 'Магадан (UTC+11)'},
      {value: 'Asia/Kamchatka', label: 'Камчатка (UTC+12)'},
    ],
  },
  {
    label: 'Европа',
    zones: [
      {value: 'Europe/London', label: 'Лондон (UTC+0)'},
      {value: 'Europe/Berlin', label: 'Берлин (UTC+1)'},
      {value: 'Europe/Paris', label: 'Париж (UTC+1)'},
      {value: 'Europe/Helsinki', label: 'Хельсинки (UTC+2)'},
      {value: 'Europe/Istanbul', label: 'Стамбул (UTC+3)'},
    ],
  },
  {
    label: 'Кавказ',
    zones: [{value: 'Asia/Yerevan', label: 'Ереван (UTC+4)'}],
  },
  {
    label: 'Азия',
    zones: [
      {value: 'Asia/Dubai', label: 'Дубай (UTC+4)'},
      {value: 'Asia/Tashkent', label: 'Ташкент (UTC+5)'},
      {value: 'Asia/Almaty', label: 'Алматы (UTC+6)'},
      {value: 'Asia/Bangkok', label: 'Бангкок (UTC+7)'},
      {value: 'Asia/Shanghai', label: 'Шанхай (UTC+8)'},
      {value: 'Asia/Tokyo', label: 'Токио (UTC+9)'},
      {value: 'Asia/Seoul', label: 'Сеул (UTC+9)'},
    ],
  },
  {
    label: 'Америка',
    zones: [
      {value: 'America/New_York', label: 'Нью-Йорк (UTC-5)'},
      {value: 'America/Chicago', label: 'Чикаго (UTC-6)'},
      {value: 'America/Denver', label: 'Денвер (UTC-7)'},
      {value: 'America/Los_Angeles', label: 'Лос-Анджелес (UTC-8)'},
      {value: 'America/Sao_Paulo', label: 'Сан-Паулу (UTC-3)'},
    ],
  },
  {
    label: 'Другие',
    zones: [
      {value: 'UTC', label: 'UTC'},
      {value: 'Pacific/Auckland', label: 'Окленд (UTC+12)'},
      {value: 'Australia/Sydney', label: 'Сидней (UTC+10)'},
    ],
  },
]

export const allTimezones = timezoneGroups.flatMap((g) => g.zones)
